import { User } from "@/types";
import { contractABI } from "./abi-swapper"
import { ethers } from "ethers";
import { web3 } from "../web3Config";

export const SWAP_CONTRACT_URL="0xcC8C29EeaeAB964587BeCb89E854006399b57FfA";


export function getSwapperTokenContract() {
    return new web3.eth.Contract(contractABI, SWAP_CONTRACT_URL);
}

export async function getSwapDetails() {
    const swapContract = getSwapperTokenContract()
    const astoAddress = await swapContract.methods.ASTO().call();
    const thinkAddress = await swapContract.methods.THINK().call();
    const paused = await swapContract.methods.paused().call();
    return {
        astoAddress,
        thinkAddress,
        paused
    };
}

export function swapTokenTx(amount: string) {
    const swapContract = getSwapperTokenContract();
    const data = swapContract.methods.swap(amount).encodeABI();
    const transactionParameters = {
        target: SWAP_CONTRACT_URL, // Required except during contract publications.
        data: data,
    } as {
        target: `0x${string}`;
        data: `0x${string}`;
    };
    return transactionParameters;
}